export enum BrokerageType {
    Discount = 1,
    FullService = 2,
}
